module.exports = __webpack_public_path__ + "img/dolde_links.8b59ecfd.png";